"use client"

import { type Coupon } from '@prisma/client';
import React from 'react';
import { CheckCircle, Copy, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import { currencyHelper } from '@/lib/utils';

interface DiscountCouponUIProps {
    details: Coupon
}

function DiscountCouponUI({ details }: DiscountCouponUIProps) {

    const handleCopy = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            toast(<div className='flex items-center gap-2'>
                    <CheckCircle className='size-4 shrink-0 text-green-500' />
                    Coupon code copied to clipboard
                </div>)
        } catch (error) {
            console.error("Failed to copy coupon code:", error);
            toast.error(<div className='flex items-center gap-2'>
                    <XCircle className='size-4 shrink-0 text-white' />
                    Failed to copy Coupon code to clipboard
                </div>)
        }
    };

    return (
        <div className="p-6 bg-white rounded-lg shadow-lg border border-gray-200 relative overflow-hidden">
            {/* Larger Semi-circle Cutouts for Ticket Look */}
            <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-8 h-8 rounded-full bg-white border border-gray-300 -ml-4"></div>
            <div className="absolute top-1/2 right-0 transform -translate-y-1/2 w-8 h-8 rounded-full bg-white border border-gray-300 -mr-4"></div>

            <div className='flex items-center justify-between'>
                <p className="text-xl font-semibold text-gray-800 mb-2">Coupon Code</p>
                <p onClick={() => handleCopy(details.code)} className="cursor-pointer text-2xl font-bold border-black rounded p-2  border-[1.5px] text-[#1371C4] tracking-wider flex items-center gap-2 mb-2">{details.code}<Copy className='text-gray-600' /> </p>
            </div>
            {/* Dashed Divider Line */}
            <div className="  h-[1px] w-full bg-black shadow shadow-black/65 my-4 "></div>

            {/* Coupon Code and Description */}
            {
                details.description ?
                    (<p>{details.description}</p>)
                    :
                    (<p className="text-[#00A6A6]">Book group of 3 or more & {details.type === "Flat" ? `₹${currencyHelper(details.flat_discount)}` : `${details.discount_percent}%`} off on this trip.</p>)
            }
            <p className="text-gray-600 text-xs text-end mt-2">Terms & Conditions applied*</p>
        </div>
    );
}

export default DiscountCouponUI;